export { WCPledgeSection } from './WCPledgeSection';
